import { KeyValue } from '@/main/models/common';
import { AddressByCompanyBuyerRequest} from '@/main/models/request';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum AddressTypes {
  GET_ADDRESS = '@address/GET_ADDRESS',
  SAVE_ADDRESS = '@address/SAVE_ADDRESS',
  RESET_REDUCER_ADDRESS = '@address/RESET_REDUCER_ADDRESS'
}

export interface AddressState {
  readonly address: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetAddress {
  type: typeof AddressTypes.GET_ADDRESS;
  payload: {
    request: AddressByCompanyBuyerRequest;
    keyReducer: string;
  };
}

export interface SaveAddress {
  type: typeof AddressTypes.SAVE_ADDRESS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerAddress {
  type: typeof AddressTypes.RESET_REDUCER_ADDRESS;
}

export type AddressActionTypes = GetAddress | SaveAddress | ResetReducerAddress;

